import type { Error, Validators } from '@ps/web-shared-validators';
import {
  getValidatorsForLicense,
  minLength as minLengthFactory,
  noWhiteStartOrEnd,
  required
} from '@ps/web-shared-validators';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  TXTWCL_Please_enter_your_addressX,
  TXTWCL_Please_try_againX_This_doesnXt_ELL,
  TXTWCL_Please_try_againX_This_must_be_ELL
} from './address.messages.json';

const streetFormat = (value: string) =>
  (/[A-za-z]/.test(value) && /\d/.test(value) && /[\s\-.]/.test(value)) ||
  /general delivery|poste restante/.test(value);

export const address =
  (country: string, message: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && ['CA', 'US'].indexOf(country) < 0 ? true : streetFormat(value),
    message
  });

const ADDRESS_MIN_LENGTH = 4;
export const ADDRESS_MAX_LENGTH = 80;

export const useAddressFieldValidators = (
  countryProp?: string,
  requiredMessage?: Error['message']
): Validators => {
  const site = useSelector(select.cms.getSiteId);
  const country = useSelector(select.account.getCountry) as string;

  return [
    noWhiteStartOrEnd,
    required(requiredMessage || TXTWCL_Please_enter_your_addressX),
    minLengthFactory(ADDRESS_MIN_LENGTH, {
      ...TXTWCL_Please_try_againX_This_must_be_ELL,
      values: { 0: ADDRESS_MIN_LENGTH }
    }),
    ...getValidatorsForLicense(site, 'address'),
    address(countryProp || country, TXTWCL_Please_try_againX_This_doesnXt_ELL)
  ];
};
